import { type Context, createContext, useContext } from 'react';

export type NavigationStyle = {
	backgroundColor: string;
	borderColor: string;
	borderType: 'none' | 'bottom' | 'all';
	cornerRadius: number;
	fixedAtTop: boolean;
	padding: boolean;
	textColor: string;
};

type NavigationStyleContextType = {
	options: NavigationStyle | null;
	setOptions: (options: NavigationStyle) => void;
};

const noop = () => {};

export const NavigationStyleContext: Context<NavigationStyleContextType> =
	createContext<NavigationStyleContextType>({
		options: null,
		setOptions: noop,
	});

export const useNavigationStyle = (): NavigationStyleContextType =>
	useContext(NavigationStyleContext);
